__turbopack_context__.v({
  "accordion-slide-down": "animations-module__wQ5cPW__accordion-slide-down",
  "accordion-slide-up": "animations-module__wQ5cPW__accordion-slide-up",
  "animate-accordion-slide-down": "animations-module__wQ5cPW__animate-accordion-slide-down",
  "animate-accordion-slide-up": "animations-module__wQ5cPW__animate-accordion-slide-up",
  "animate-chevron-closed": "animations-module__wQ5cPW__animate-chevron-closed",
  "animate-chevron-open": "animations-module__wQ5cPW__animate-chevron-open",
  "animate-content-fade-in": "animations-module__wQ5cPW__animate-content-fade-in",
  "animate-content-fade-out": "animations-module__wQ5cPW__animate-content-fade-out",
  "chevron-rotate-closed": "animations-module__wQ5cPW__chevron-rotate-closed",
  "chevron-rotate-open": "animations-module__wQ5cPW__chevron-rotate-open",
  "content-fade-in": "animations-module__wQ5cPW__content-fade-in",
  "content-fade-out": "animations-module__wQ5cPW__content-fade-out",
});
